module.exports = fox._r("fonts/infinity-icon-set.svg", __webpack_public_path__ + "fonts/infinity-icon-set.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/infinity-icon-set.svg
// module id = 966
// module chunks = 4